import React from 'react';
import replaceCharacters from '../../components/utilities/helpers';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import { TooltipTableCell } from '../../components/utilities/Table/TooltipTableCell';
import {
    RequestDays,
    RequestIdWithWarning,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';

const requestsListStatus = [
    {
        id: 'bolsa_general_coordinado_mesa_ayuda',
        label: 'BOLSA GENERAL',
        status: '10',
        responsable: null,
        offices: true,
        officeNotInitial: true,
        groupCounterGestion: 2,
        columns: [
            RequestIdWithWarning(),
            RequestDays('gestionsolicitud.fecha_creacion'),
            {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: 'Oficina',
                accessor: 'oficina.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                typeId: 'HeaderClient',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: () => 'Responsable',
                id: 'responsable',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.responsable?.name}
                        tooltipText={row.original.responsable?.email}
                    />
                ),
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
        ],
        buttonAction: [
            { name: 'reassingUserRequest' },
            { name: 'deleteUserRequest' },
        ],
    },
    {
        id: 'procesadas_coordinado_mesa_ayuda',
        label: 'PROCESADAS',
        status: '20,30,40,50,60,70,80,90',
        responsable: null,
        offices: true,
        columns: [
            RequestIdWithWarning(),
            {
                Header: 'Fecha creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: 'Oficina',
                accessor: 'oficina.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: () => 'Responsable',
                id: 'responsable',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.responsable?.name}
                        tooltipText={row.original.responsable?.email}
                    />
                ),
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
            {
                Header: () => 'Causal',
                id: 'causal_id',
                Cell: ({ row }) => {
                    return (
                        <span className="">
                            {row.original.causal
                                ? row.original.causal.label
                                : '-'}
                        </span>
                    );
                },
            },
        ],
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'eliminadas_coordinado_mesa_ayuda',
        label: 'ELIMINADAS',
        status: '900',
        responsable: null,
        offices: true,
        columns: [
            RequestIdWithWarning(),
            {
                Header: 'Fecha eliminación',
                accessor: 'gestionsolicitud.fecha_eliminacion',
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: 'Regional',
                accessor: 'oficina.label',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: () => 'Responsable',
                id: 'responsable',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.responsable?.name}
                        tooltipText={row.original.responsable?.email}
                    />
                ),
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
            {
                Header: () => 'Causal',
                id: 'causal_id',
                Cell: ({ row }) => {
                    return (
                        <span className="">
                            {row.original.causal
                                ? row.original.causal.label
                                : '-'}
                        </span>
                    );
                },
            },
        ],
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
